import styled from "@emotion/styled";

export const BrandsSubMenu = styled.div`
    padding: 17px 0 9px 0;

    .br-header {
        max-width: 85%;
        display: flex;
        margin: 0 17px 17px 15%;
        height: 32px;
        justify-content: right;
    }

    .br-content {
        display: flex;
        align-items: center;
        width: 100%;
        padding-right: 5px;
        background-color: rgba(225, 236, 240, 0.32);

        .br-categories {
            position: relative;
            top: 0;
            width: 17%;
            align-self: flex-start;
            height: inherit;
            height: 380px;
            display: flex;
        }
    }
`;
